module.exports = __webpack_public_path__ + "b5895d53230a00d6e3205b1826cbfeef.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/ic_air.p_48.png
 ** module id = 663
 ** module chunks = 0
 **/